var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 23,
    viewBox: "0 0 12 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32515 0.000114441C2.55996 -0.000720978 2.79196 0.053442 3.00411 0.158623C3.21626 0.263802 3.40316 0.417328 3.55109 0.607914L11.1425 10.4641C11.3736 10.7581 11.5 11.1268 11.5 11.5072C11.5 11.8877 11.3736 12.2564 11.1425 12.5504L3.2839 22.4066C3.01712 22.742 2.63376 22.953 2.21816 22.993C1.80256 23.0331 1.38875 22.899 1.06778 22.6201C0.746814 22.3413 0.544969 21.9406 0.506651 21.5062C0.468332 21.0719 0.596681 20.6394 0.863461 20.3039L7.88901 11.499L1.09922 2.69414C0.907024 2.45302 0.784939 2.1594 0.747407 1.84803C0.709875 1.53666 0.758468 1.22056 0.887436 0.937153C1.0164 0.65374 1.22035 0.414873 1.47514 0.248812C1.72993 0.0827503 2.0249 -0.00355339 2.32515 0.000114441Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.e26ac3c2b59b5ab3751124e4cbd01377.svg";
export { ForwardRef as ReactComponent };